import React from 'react'
import { observer } from 'mobx-react-lite'
import { MDBIcon, MDBCollapse } from 'mdb-react-ui-kit'
import Store from './../../store'

import './Sidebar.component.scss'

const Sidebar = () => {
  const handleManualClick = manual => {
    Store.selectManual(manual.id)
  }

  const handleSectionToggle = sectionId => {
    Store.toggleSection(sectionId)
  }

  const isExpanded = sectionId => {
    return Store.expandedSections.includes(sectionId)
  }

  const isSelected = manualId => {
    return Store.selectedManualPath === manualId
  }

  if (Store.isLoading && Store.manualTree.length === 0) {
    return (
      <div id='SidebarComponent' className='sidebar'>
        <div className='sidebar__loading'>Loading manuals...</div>
      </div>
    )
  }

  if (Store.manualTree.length === 0) {
    return (
      <div id='SidebarComponent' className='sidebar'>
        <div className='sidebar__empty'>No manuals available</div>
      </div>
    )
  }

  return (
    <div id='SidebarComponent' className='sidebar'>
      <div className='sidebar__header'>
        <h3 className='sidebar__title'>Documentation</h3>
      </div>
      <nav className='sidebar__nav'>
        {Store.manualTree.map(category => (
          <div key={category.id} className='sidebar__category'>
            <button type='button' className='sidebar__category-header' onClick={() => handleSectionToggle(category.id)}>
              <span className='sidebar__category-title'>{category.title}</span>
              <MDBIcon
                icon={isExpanded(category.id) ? 'chevron-down' : 'chevron-right'}
                className='sidebar__category-icon'
              />
            </button>
            <MDBCollapse open={isExpanded(category.id)}>
              <div className='sidebar__category-content'>
                {category.children.map(manual => (
                  <button
                    key={manual.id}
                    type='button'
                    className={`sidebar__manual ${isSelected(manual.id) ? 'active' : ''}`}
                    onClick={() => handleManualClick(manual)}
                  >
                    <MDBIcon icon='file-alt' className='sidebar__manual-icon' />
                    <span className='sidebar__manual-title'>{manual.title}</span>
                  </button>
                ))}
              </div>
            </MDBCollapse>
          </div>
        ))}
      </nav>
    </div>
  )
}

export default observer(Sidebar)
